<template>
    <div>
        <el-tabs
            type="border-card"
            stretch
            v-model="activeName"
            v-if="!isShow"
            @tab-click="handleClick"
        >
            <el-tab-pane name="baseCourse">
                <span slot="label">
                    课程：
                    <span class="num"> {{totalCount.baseCourseCount}}门 </span>
                </span>
                <Select type="baseCourse" @change="handleChange" @export="handleExport"></Select>
                <Table
                    v-if="tableName === 'Table'"
                    :tableData="tableData"
                    @linkToCourse="linkToCourse"
                    type="baseCourse"
                    v-loading="loading"
                ></Table>
                <pagination
                  v-show="total > 0"
                  :total="total"
                  :page.sync="queryParams.page"
                  :limit.sync="queryParams.pageSize"
                  @pagination="handleChangeSize"
                />
            </el-tab-pane>
            <el-tab-pane name="resourcesCourse">
                <span slot="label">
                    课程资源 ：
                    <span class="num"> {{totalCount.videoCount}}个 </span>
                </span>
                <Select @change="handleChange" @export="handleExport"></Select>
                <Table  :tableData="tableData" type="resourcesCourse"  @linkToCourse="linkToCourse"  v-loading="loading"></Table>
                <pagination
                  v-show="total > 0"
                  :total="total"
                  :page.sync="queryParams.page"
                  :limit.sync="queryParams.pageSize"
                  @pagination="handleChangeSize"
                />
            </el-tab-pane>
            <el-tab-pane name="totalCourse">
                <span slot="label">
                    开课总批次：
                    <span class="num"> {{totalCount.kkCount}}批 </span>
                </span>
                <Select type="totalCourse" @change="handleChange" @export="handleExport"></Select>
                <Table :tableData="tableData" type="totalCourse"  v-loading="loading"></Table>
                <pagination
                  v-show="total > 0"
                  :total="total"
                  :page.sync="queryParams.page"
                  :limit.sync="queryParams.pageSize"
                  @pagination="handleChangeSize"
                />
            </el-tab-pane>
        </el-tabs>
        <dibbleList v-if="isShow" :listType="activeName" :selectItem="selectItem"></dibbleList>
    </div>
</template>

<script>
import Select from "./select.vue";
import Table from "./Table.vue";
import { getBaseCourseList, getCourseList,getCourseTotalCount,getBatchList } from "@/api/TeachingStatistics";
import pagination from "../ClassStatistics/Pagination/index.vue";
import dibbleList from './dibbleList.vue'
export default {
  props:['isReset','forms','listType','isReflesh'],
  components: {
      Table,
      Select,
      pagination,
      dibbleList,
  },
  data() {
    return {
      activeName: "baseCourse",
      tableName: "Table",
      tableData: [],
      isShow:false,
      selectItem:{},
      totalCount:{},
      queryParams:{pageSize:10,page:1},
      total:0,
      loading:true, // 遮罩层
      courseForm:{},
      newForms: this.forms
    };
  },
  methods: {
      // 标签页切换
      async handleClick(page) {
        this.tableName = "Table",this.listType;
        this.isShow = false;
        this.queryParams.page = 1;
        this.loading = true;
        this.$emit('update:isReflesh',false)
        if(page&&page>1){this.queryParams.page = page}
        setTimeout(()=>{
          getCourseTotalCount(this.newForms).then(res=>{
            if(res.data.code === 100000){
              this.totalCount = res.data.data;
            }
          });
        },2000)
        if (this.activeName === "baseCourse") {
          const {data} = await getBaseCourseList({...this.newForms,...this.queryParams});
          if(data.code===100000){
            this.tableData = data.data.list;
            this.total = data.data.total || 0;
            this.loading = false;
          }
        }
        if (this.activeName === "resourcesCourse") {
          const {data} = await getCourseList({...this.newForms,...this.queryParams});
          if(data.code===100000){
            this.tableData = data.data.list;
            this.total = data.data.total || 0;
            this.loading = false;
          }
        }
        if (this.activeName === "totalCourse") {
          const {data} = await getBatchList({...this.newForms,...this.queryParams});
          if(data.code===100000){
            this.tableData = data.data.list;
            this.total = data.data.total || 0;
            this.loading = false;
          }
        }
      },
      async linkToCourse(courseId,row) {
        // const res = await getCourseList({
        //     courseId,
        // });
        // this.isShow = true;
        this.$emit('update:isReset',false);
        // console.log(res.data.data);
        // this.tableData = res.data.data;
        this.tableName = "CourseTable";
        this.isShow = true;
        this.selectItem = row;
      },
      /** 分页事件 */
      handleChangeSize(page){
        this.handleClick(page.page)
      },
      /** 搜索事件 */
      async handleChange(item){
        this.courseForm = item;
        this.loading = true;
        if (this.activeName === "baseCourse") {
          const {data} = await getBaseCourseList({...this.newForms,...this.queryParams,...this.courseForm});
          if(data.code===100000){
            this.tableData = data.data.list;
            this.total = data.data.total || 0;
            this.loading = false;
          }
        }
        if (this.activeName === "resourcesCourse") {
          const {data} = await getCourseList({...this.newForms,...this.queryParams,...this.courseForm});
          if(data.code===100000){
            this.tableData = data.data.list;
            this.total = data.data&&data.data.total?data.data.total:0;
            this.loading = false;
          }
        }
        if (this.activeName === "totalCourse") {
          const {data} = await getBatchList({...this.newForms,...this.queryParams,...this.courseForm});
          if(data.code===100000){
            this.tableData = data.data.list;
            this.total = data.data&&data.data.total?data.data.total:0;
            this.loading = false;
          }
        }
      },
      /** 导出结果事件 */
      handleExport(item){
        this.courseForm = item;
        if(this.activeName==='baseCourse'){
          window.open(
            `${this.url}/zkfz/statistics/baseCourseListExport?courseName=${item.courseName}&courseCode=${item.courseCode}&examinationType=${item.examinationType}&coursePoint=${item.coursePoint}&schoolId=${this.newForms.schoolId!==undefined?this.newForms:""}&timeRange=${this.newForms.timeRange!==undefined?this.newForms.timeRange:""}&startTime=${this.newForms.startTime!==undefined?this.newForms.startTime:""}&endTime=${this.newForms.endTime!==undefined?this.newForms.endTime:""}`
          );
        }else if(this.activeName==='resourcesCourse'){
          window.open(
          `${this.url}/zkfz/statistics/courseListExport?courseName=${item.courseName}&courseCode=${item.courseCode}&examinationType=${item.examinationType}&teacherName=${item.teacherName}&schoolName=${item.schoolName}&courseAttribute=${item.courseAttribute}&examCategory=${item.examCategory}&schoolId=${this.newForms.schoolId!==undefined?this.newForms.schoolId:""}&timeRange=${this.newForms.timeRange!==undefined?this.newForms.timeRange:""}&startTime=${this.newForms.startTime!==undefined?this.newForms.startTime:""}&endTime=${this.newForms.endTime!==undefined?this.newForms.endTime:""}`
          )
        }else if(this.activeName==='company'){
          window.open(
          `${this.url}/zkfz/statistics/albumMhmListExport?courseGroupCode=${form.courseGroupCode}&degreeName=${form.degreeName}&eduLevel=${form.eduLevel}&enrollMajorCode=${form.enrollMajorCode}&mainSchoolCode=${form.mainSchoolCode}&mainSchoolName=${form.mainSchoolName}&majorCode=${form.majorCode}&majorName=${form.majorName}&schoolId=${this.newForms.schoolId!==undefined?this.newForms.schoolId:""}&timeRange=${this.newForms.timeRange!==undefined?this.newForms.timeRange:""}&startTime=${this.newForms.startTime!==undefined?this.newForms.startTime:""}&endTime=${this.newForms.endTime!==undefined?this.newForms.endTime:""}`
          )
        }
      }
  },
  mounted() {
    this.handleClick();
  },
  computed: {
    url() {
      let url = window.location.protocol + "//" + window.location.host;
      if (window.location.host == "localhost:5001"  ) {
        url = "http://gz.hnjk.net";
      }
      return url;
    },
  },
  watch:{
    listType:function(val){
      this.isShow = false;
    },
    isReset:function(val){
      if(val){
        this.isShow = false;
      }
    },
    // isReflesh: function(val){
    //   if(val){
    //     this.handleClick();
    //   }
    // },
    forms: {
      handler(newValue,oldValue){
        this.newForms = newValue;
        // this.handleClick();
        if(this.isReflesh){
          setTimeout(()=>{
            this.handleClick()
          },2000)
        }
      },
      deep: true,
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-tabs__header {
    background-color: #64b0ff;
    span {
        color: #fff;
        .num {
            font-size: 24px;
            font-weight: 700;
            color: red;
        }
        .num:hover {
            color: #409eff;
        }
    }
}
::v-deep .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
    background-color: #d7d7d7;
    border: 0;
    span {
        color: #000;
        .num {
            color: red;
        }
    }
}
::v-deep .el-tabs--border-card > .el-tabs__header {
    height: 70px;
    padding-top: 30px;
    margin-top: 3px;
}
</style>